module.exports = __webpack_public_path__ + "static/media/singing.3efcdc0e.jpg";